import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_DATA_FEATURE, UserState } from '../user-data.state';

export const getUserState = createFeatureSelector<UserState>(USER_DATA_FEATURE);

export const selectUserData = createSelector(getUserState, (state: UserState) => state.b2bCustomers);